// extracted by mini-css-extract-plugin
export default {"navbar_container":"NavBar_navbar_container__1oi7E","navbar_border":"NavBar_navbar_border__CY-hB","sticky-nav":"NavBar_sticky-nav__GR4aa"};